var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "131.000000pt",
    height: "151.000000pt",
    viewBox: "0 0 131.000000 151.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,151.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883 1491 c-137 -47 -243 -183 -243 -311 0 -37 2 -40 28 -40 54 0 122 32 178 83 72 65 105 132 112 220 5 77 6 76 -75 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 1147 c-72 -24 -120 -54 -167 -105 -94 -100 -123 -193 -115 -371 6 -150 32 -244 109 -392 87 -168 179 -260 272 -274 33 -5 63 0 135 25 122 42 176 42 308 0 97 -31 106 -32 149 -20 86 24 220 172 284 314 17 36 30 71 30 79 0 7 -16 21 -36 32 -53 28 -129 117 -148 171 -9 26 -16 80 -16 119 0 91 37 171 112 240 59 56 58 59 -18 118 -107 82 -279 100 -427 43 -85 -33 -112 -33 -190 1 -74 32 -215 42 -282 20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.cab2ecaa8ea6ccd93b635ae1621f39a4.svg";
export { ForwardRef as ReactComponent };